import { css } from '@emotion/react';

export const formSelectOrAddComboboxAutocompleteStyles = css`
  .MuiInputBase-root {
    padding-bottom: 0;
    padding-top: 0;
  }
`;
